import request from '@/utils/request';

// 广告名称同步
export async function fetchAdEditOnline(data) {
  return request(`/api/ad-edit-online`, {
    removeBlankProperty: true,
    data,
    method: 'POST',
  });
}

// 广告账号类别-批量设置
export async function batchSetAdAccountCategory(data) {
  return request(`/api/ad-account-category/batch-set`, {
    removeBlankProperty: true,
    data,
    method: 'POST',
  });
}

// 广告账号类别-批量清除
export async function batchClearAdAccountCategory(data) {
  return request(`/api/ad-account-category/batch-clear`, {
    removeBlankProperty: true,
    data,
    method: 'POST',
  });
}

// 广告账号类别-创建
export async function createAdAccountCategory(data) {
  return request(`/api/ad-account-category/create`, {
    removeBlankProperty: true,
    data,
    method: 'POST',
  });
}

// 广告账号类别-选项列表
export async function getAdAccountCategoryOptions(data) {
  return request(`/api/ad-account-category/options`, {
    data,
    method: 'POST',
  });
}

// 配置列表
export async function getAdAccountCategoryParentEntityList(data) {
  return request(`/api/ad-account-category/parent-entity/list`, {
    data,
    method: 'POST',
    removeBlankProperty: true,
  });
}
// 父主体选项列表（所属公司选项列表）
export async function getAdAccountCategoryParentEntityOptions(data) {
  return request(`/api/ad-account-category/parent-entity/options`, {
    data,
    method: 'POST',
  });
}

// 批量添加配置
export async function batchAddAdAccountCategory(data) {
  return request(`/api/ad-account-category/parent-entity/batch-add`, {
    data,
    method: 'POST',
  });
}

// 批量修改配置
export async function batchUpdateAdAccountCategory(data) {
  return request(`/api/ad-account-category/parent-entity/batch-update`, {
    data,
    method: 'POST',
  });
}

// 批量删除配置  /api/ad-account-category/parent-entity/batch-delete
export async function batchDeleteAdAccountCategory(data) {
  return request(`/api/ad-account-category/parent-entity/batch-delete`, {
    data,
    method: 'POST',
  });
}
